









































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { reportList, setAuth } from '@/api/report';
import selectMember from '@/components/project/selectMember.vue';
import { reportMap } from '@/common/constant';
import { hasPermission } from '@/utils/utils';
import { mapGetters } from 'vuex';
import downloadStreamFile from '@/assets/js/downloadStreamFile';
import moment from 'moment';

const columns = [
  { title: '报表名称', dataIndex: 'name', key: 'name', align: 'center' },
  { title: '数据口径', dataIndex: 'caliber', key: 'caliber', align: 'center' },
  { title: '端', dataIndex: 'device', key: 'device' },
  {
    title: '操作',
    key: 'action',
    align: 'center',
    scopedSlots: {
      customRender: 'action'
    }
  }
];

@Component({
  components: { selectMember },
  computed: { ...mapGetters(['userInfo']) }
})
class FORMLIST extends Vue {
  userInfo: any;
  columns: any[] = columns;
  data: any[] = [];
  showModal: boolean = false;
  reportObj: object = {};
  reportMap: object = reportMap;
  setAuthPermission: boolean = false;
  lpExportPermisson: boolean = false;

  created() {
    this.getList();
    const { permissions: queue } = this.userInfo || {};
    this.setAuthPermission = hasPermission(queue, '/data/setPermission');
  }

  async getList() {
    try {
      let res = await reportList();
      if (res.code === 200) {
        this.data = res.data;
        let index = this.data.findIndex(_ => _.id === 9);
        if (index > -1) {
          let exportList = this.data[index].export || [];
          if (exportList.findIndex(_ => _.id === this.userInfo.id) > -1) {
            this.lpExportPermisson = true;
          } else {
            this.lpExportPermisson = false;
          }
        } else {
          this.lpExportPermisson = false;
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  openModal(obj) {
    this.showModal = true;
    this.reportObj = {
      ...obj,
      query: obj.query.map(_ => {
        return { id: _.id, nickname: _.name };
      }),
      export: obj.export.map(_ => {
        return { id: _.id, nickname: _.name };
      })
    };
  }

  closeModal() {
    this.showModal = false;
    this.reportObj = {};
  }

  chosePerson(index, val) {
    this.reportObj['query'] = val;
  }

  delPerson(index, val) {
    this.reportObj['query'] = this.reportObj['query'].filter(_ => _.id !== val.id);
  }

  choseExportPerson(index, val) {
    this.reportObj['export'] = val;
  }

  delExportPerson(index, val) {
    this.reportObj['export'] = this.reportObj['export'].filter(_ => _.id !== val.id);
  }

  async setPermission() {
    try {
      let queryIds: any[] = [];
      this.reportObj['query'].forEach(_ => {
        queryIds.push(_.id);
      });
      let exportIds: any[] = [];
      this.reportObj['export'].forEach(_ => {
        exportIds.push(_.id);
      });
      let res = await setAuth({ id: this.reportObj['id'], queryIds: queryIds.join(',') || '', exportIds: exportIds.join(',') });
      if (res.code === 200) {
        this.$message.success('success');
        this.closeModal();
        this.getList();
      }
    } catch (err) {
      console.log(err);
    }
  }

  getDetail(obj) {
    this.$router.push({ path: '/data/report/' + reportMap[obj.id] });
  }

  async exportReport(obj) {
    try {
      let date = moment(new Date()).format('YYYYMMDD');
      let data = { reportId: obj.id };
      downloadStreamFile('/lp/export', data, `lp报表_${date}`);
    } catch (err) {
      console.log(err);
    }
  }
}

export default FORMLIST;
